import EfCardsA from '@elem/ui/ef-cards-a';
import EfSpec from '@elem/ui/ef-spec';
import EfTitle from '@elem/ui/ef-title';
import { PageNavType } from '../PageNav';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';

export default function TheComp() {
    const { locale = 'us' } = useRouter();
    const { t } = useLang('theProduct.ListA');

    const listA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1732500531355/ListA-1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1732500532073/ListA-h5-1.jpg',
            title: t('item1_title'),
            link: `${t('Read_More')} >`,
            href: `https://blog.ecoflow.com/${locale}/can-ups-supply-power-for-my-home`,
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1732500531502/ListA-2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1732500532329/ListA-h5-2.jpg',
            title: t('item2_title'),
            link: `${t('Read_More')} >`,
            href: `https://blog.ecoflow.com/${locale}/whats-best-ups-backup-battery-for-computers`,
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1732500531782/ListA-3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1732500532605/ListA-h5-3.jpg',
            title: t('item3_title'),
            link: `${t('Read_More')} >`,
            href: `https://blog.ecoflow.com/${locale}}/use-portable-power-station-as-ups-power-supply`,
        },
    ];
    return (
        <div className={styles.TheComp} id={PageNavType.Blog}>
            <EfSpec />
            <EfTitle>{t('title')}</EfTitle>
            <EfCardsA className="list-a-cards" list={listA} />
        </div>
    );
}
